import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import AboutSection from './components/AboutSection';
import ComparisonSection from './components/ComparisonSection';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import ArticleCTASection from './components/ArticleCTASection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL;

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'Kakobuy Polska Guide',
          url: siteUrl,
          description: 'Niezależny przewodnik i platforma odkrywania produktów Kakobuy Spreadsheet dla polskich użytkowników. Znajduj najlepsze produkty z Chin szybciej dzięki sprawdzonym listom produktów.',
          inLanguage: 'pl',
          potentialAction: {
            '@type': 'SearchAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: `${siteUrl}/?q={search_term_string}`,
            },
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <Navbar />
      <Hero />
      <CategorySection />
      <AboutSection />
      <ComparisonSection />
      <SafetySection />
      <FAQSection />
      <ArticleCTASection />
      <Footer />
    </main>
  );
}